import type { CourseSearchRecord, CourseSummary, OfficialOffering } from "../../shared/types";
import { compareTermsByMostRecent } from "../../shared/terms";

export function formatOffering(offering: OfficialOffering): string {
  if (offering.periods.length === 0) {
    return offering.term;
  }
  return `${offering.periods.join("/")} - ${offering.term}`;
}

function sortOfferingsByMostRecent(offerings: OfficialOffering[]): OfficialOffering[] {
  return [...offerings].sort((left, right) => compareTermsByMostRecent(left.term, right.term));
}

export function formatCourseOfferingPreview(
  course:
    | Pick<CourseSummary, "officialOfferings" | "offeredLabel" | "offeredPeriods">
    | Pick<CourseSearchRecord, "offeringPreview">,
): string | null {
  if ("offeringPreview" in course) {
    return course.offeringPreview;
  }

  const sortedOfferings = sortOfferingsByMostRecent(course.officialOfferings);
  if (sortedOfferings.length > 0) {
    return `Offered ${formatOffering(sortedOfferings[0])}`;
  }

  if (course.offeredLabel) {
    return course.offeredLabel;
  }

  if (course.offeredPeriods.length > 0) {
    return `Offered ${course.offeredPeriods.join(", ")}`;
  }

  return null;
}
